<template>
  <router-view />
  <Toast />
</template>

<style lang="scss">
// Import Main styles for this application
@import "styles/style";
@import "primeflex/primeflex.css";
@import "primevue/resources/themes/lara-light-green/theme.css";
@import "primeicons/primeicons.css";
@import "assets/icons/landing.css";
@import "assets/icons/css-file-icons.css";
</style>
